import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f17da342"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "search-title" }, "高级查询", -1))
const _hoisted_2 = { class: "search-content" }
const _hoisted_3 = { class: "right-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("更新")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_role_select = _resolveComponent("role-select")!
  const _component_service_desk_select = _resolveComponent("service-desk-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "table-search-component ant-popover-inner",
    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        "label-col": _ctx.labelCol,
        model: _ctx.searchModel,
        rules: _ctx.rules,
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "姓名",
            name: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.searchModel.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchModel.name) = $event)),
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Email",
            name: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.searchModel.email,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchModel.email) = $event)),
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "手机号",
            name: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.searchModel.phone,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchModel.phone) = $event)),
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "ExternalId",
            name: "externalId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.searchModel.externalId,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchModel.externalId) = $event)),
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "角色",
            name: "roleId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_role_select, {
                modelValue: _ctx.searchModel.roleId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchModel.roleId) = $event)),
                allowClear: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "首选客服组",
            name: "defaultServiceDeskId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_service_desk_select, {
                modelValue: _ctx.searchModel.defaultServiceDeskId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchModel.defaultServiceDeskId) = $event)),
                allowClear: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "所属客服组",
            name: "serviceDeskId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_service_desk_select, {
                modelValue: _ctx.searchModel.serviceDeskId,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchModel.serviceDeskId) = $event)),
                allowClear: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "账号状态",
            name: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.searchModel.status,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchModel.status) = $event)),
                "option-label-prop": "label",
                allowClear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (option) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: option.value,
                      value: option.value,
                      label: option.label
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.handleSubmit
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label-col", "model", "rules"])
    ])
  ]))
}